import React from 'react';
import { Auth } from 'aws-amplify';
import { publicRuntimeConfig } from '../../../config';
import { withNavigation } from '../../../hoc';
import { FlexContainer } from '../../layouts/Wrapper/Base.components';
import { Button } from '../../common';

const LoginForm = ({ navigate, ...props }) => {
    const sendLogin = () => {
        const authConfig = Auth.configure();
        const { userPoolWebClientId } = authConfig;
        const { domain, redirectSignIn } = authConfig.oauth;
        const { name, grantFlow } = publicRuntimeConfig.settings;
        const url = `https://${domain}/oauth2/authorize?identity_provider=${name}&redirect_uri=${redirectSignIn}&response_type=${grantFlow}&client_id=${userPoolWebClientId}`;
        sessionStorage.setItem('bo_sess', true); // Launch hosted UI
        window.location.assign(url);
    };

    const isProd = publicRuntimeConfig.settings.isProd;
    const CommonButton = props => <Button {...props} minWidth='150px' maxWidth='185px' style={{ margin: '5px' }} />;

    return (
        <FlexContainer justify={isProd ? 'center' : 'space-between'}>
            {!isProd && <CommonButton text='BACKOFFICE' onClick={() => navigate('/login')} />}
            <CommonButton text={isProd ? 'Ingresar' : 'ADFS'} onClick={() => sendLogin()} />
        </FlexContainer>
    );
};

export default withNavigation(LoginForm);
